import { useEffect, useRef, useState } from "react";

function RedesignedHeader({ onThemeToggle, currentTheme }) {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const headerContainerRef = useRef(null);

    const scrollToSection = (sectionClass) => {
        const element = document.querySelector(sectionClass);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    useEffect(() => {
        const closeOnDesktop = () => {
            if (window.innerWidth > 768) {
                setIsMobileMenuOpen(false);
            }
        };

        window.addEventListener('resize', closeOnDesktop);
        return () => window.removeEventListener('resize', closeOnDesktop);
    }, []);

    useEffect(() => {
        if (!isMobileMenuOpen) return;

        const closeOnOutsidePress = (event) => {
            const container = headerContainerRef.current;
            if (!container) return;
            if (!container.contains(event.target)) {
                setIsMobileMenuOpen(false);
            }
        };

        const closeOnEscape = (event) => {
            if (event.key === 'Escape') {
                setIsMobileMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', closeOnOutsidePress);
        document.addEventListener('touchstart', closeOnOutsidePress, { passive: true });
        document.addEventListener('keydown', closeOnEscape);

        return () => {
            document.removeEventListener('mousedown', closeOnOutsidePress);
            document.removeEventListener('touchstart', closeOnOutsidePress);
            document.removeEventListener('keydown', closeOnEscape);
        };
    }, [isMobileMenuOpen]);

    const handleSectionNav = (sectionClass) => (e) => {
        e.preventDefault();
        scrollToSection(sectionClass);
        setIsMobileMenuOpen(false);
    };

    const handleContact = () => {
        setIsMobileMenuOpen(false);
        window.location.href = 'mailto:info@alphacogs.co.uk';
    };

    return (
        <header className="cinematic-header">
            <div className="cinematic-header-container" ref={headerContainerRef}>
                <div className="cinematic-logo">
                    <img src="/assets/img/logo-dark.svg" alt="Emotional Intelligence Engine" style={{background: 'transparent'}} />
                    <div className="cinematic-logo-text">
                        <div className="logo-text-full">AlphaHub - Emotional Intelligence Engine</div>
                        <div className="logo-text-stacked">
                            <span className="logo-text-kicker">AlphaHub</span>
                            <span>Emotional Intelligence Engine</span>
                        </div>
                    </div>
                </div>
                <button
                    type="button"
                    className="cinematic-mobile-menu-toggle"
                    aria-label="Toggle navigation menu"
                    aria-expanded={isMobileMenuOpen}
                    onClick={() => setIsMobileMenuOpen((prev) => !prev)}
                >
                    <span />
                    <span />
                    <span />
                </button>

                <nav className={`cinematic-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
                    <a href="#demo" onClick={handleSectionNav('.redesign-use-cases')} className="cinematic-nav-link">How It Works</a>
                    <a href="#industries" onClick={handleSectionNav('.redesign-industries')} className="cinematic-nav-link">Industries</a>
                    <a href="#use-cases" onClick={handleSectionNav('.redesign-use-cases')} className="cinematic-nav-link">EIE in Action</a>
                    <a href="#case-studies" onClick={handleSectionNav('.redesign-case-studies')} className="cinematic-nav-link">Why It Matters</a>
                    <div className="cinematic-nav-controls">
                        <button onClick={handleContact} className="cinematic-nav-cta">Contact</button>
                        <button 
                            onClick={onThemeToggle}
                            className="cinematic-theme-toggle"
                            title={`Switch to ${currentTheme === 'passion' ? 'Clarity' : 'Passion'}`}
                        >
                            {currentTheme === 'passion' ? (
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="3" width="7" height="7"/>
                                    <rect x="14" y="3" width="7" height="7"/>
                                    <rect x="14" y="14" width="7" height="7"/>
                                    <rect x="3" y="14" width="7" height="7"/>
                                </svg>
                            ) : (
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="var(--primary-accent)" stroke="var(--primary-accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                                </svg>
                            )}
                        </button>
                    </div>
                </nav>
            </div>
        </header>
    );
}

export default RedesignedHeader;
